(ns frontend.view.settings2.authorized-applications.view
    (:require
      [common.localization :as loc]
      [frontend.page-components.default-page-layout :as default-page-layout]
      [frontend.page-components.zap-toolbar :as zap-toolbar]
      [frontend.routing :as routing]
      [frontend.view.settings2.authorized-applications.db :as db]
      [frontend.view.settings2.authorized-applications.events :as events]
      [reagent.core :as r]
      [ui.components.breadcrumbs.view :as breadcrumbs]
      [ui.components.button.view :as button]
      [ui.editors.labelled-input.view :as labelled-input]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "security"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/authorized-applications)]])

(defn loading
  []
  [:div
   {:class "text-center"}
   [:i.fal.fa-spinner.fa-pulse.fa-5x]])

(defn advertisement
  []
  [:div
   {:class "px-4 py-8 mx-auto lg:w-4xl"}
   [:div
    [:div
     [:p
      {:class "p-6 flex flex-col gap-4 text-primary-regular-text bg-[url('/img/gradient-bg.png')] bg-no-repeat bg-cover rounded-md"}
      [:span
       {:class "block font-bold text-2xl"}
       "Unlock Powerful Integrations (Premium):"]

      [:ul
       {:class "flex flex-col gap-3 list-disc list-inside font-semibold text-md"}
       [:li "Connect Zapflow with your favorite tools."]
       [:li "Streamline workflows & boost efficiency."]]
      [:div
       {:class "pt-2 flex gap-2 items-center"}
       [:a
        {:class  "py-3 px-4 inline-block text-primary-regular-text font-bold border border-solid focus:border-primary-regular-border-paler hover:border-primary-regular-border-accent focus:border-primary-regular-border-accent rounded"
         :href   "mailto:support@zapflow.com"
         :target "_blank"}
        "Upgrade to Premium"]]]]]])

(defn normalize-ip-filter
  [ip-filter]
  (cond
    (string? ip-filter)
    {:name ""
     :ip   ip-filter}
    (map? ip-filter)
    {:name (or (:name ip-filter) "")
     :ip   (or (:ip ip-filter) "")}
    :else
    {:name ""
     :ip   ""}))

(defn normalize-ip-filters
  [ip-filters]
  (->> (or ip-filters [])
       (mapv normalize-ip-filter)))

(defn api-token
  [_token-state token]
  (let [local-state (r/atom (update token :token/ip-filters normalize-ip-filters))]
    (fn [token-state token]
      (let [save-disabled? (and (= (normalize-ip-filters (:token/ip-filters token))
                                   (:token/ip-filters @local-state))
                                (= (:token/device-nick-name token)
                                   (:token/device-nick-name @local-state)))]
        [:li
         [:div
          {:class "mb-3"}
          [labelled-input/view
           {:label     (loc/tr :api-token)
            :data-type :data.type/text-simple
            :value     (get @local-state :token/api-token)
            :on-change (fn [new-value]
                         (swap! local-state assoc :token/api-token new-value))}]]

         [:div
          {:class "mb-3"}
          [labelled-input/view
           {:label     (loc/tr :expires)
            :data-type :data.type/text-simple
            :value     (get @local-state :token/expires)
            :on-change (fn [new-value]
                         (swap! local-state assoc :token/expires new-value))}]]

         [:div
          {:class "mb-3"}
          [labelled-input/view
           {:label     (loc/tr :name)
            :data-type :data.type/text-simple
            :value     (:token/device-nick-name @local-state)
            :on-change (fn [new-value]
                         (swap! local-state assoc :token/device-nick-name new-value))}]]

         [:div
          {:class "flex flex-col gap-2 mb-3"}
          [:label
           (loc/tr :ip-filters)]
          (->> @local-state
               :token/ip-filters
               (map-indexed (fn [idx ip-filter]
                              ^{:key (str "api-token-" (:token/api-token token) "-" idx)}
                              [:div
                               {:class "flex items-end gap-3"}
                               [labelled-input/view
                                {:label     (loc/tr :name)
                                 :data-type :data.type/text-simple
                                 :value     (:name ip-filter)
                                 :on-change (fn [new-value]
                                              (swap! local-state assoc-in [:token/ip-filters idx :name] new-value))}]
                               [labelled-input/view
                                {:label     (str "IP / CIDR " (inc idx))
                                 :data-type :data.type/text-simple
                                 :value     (:ip ip-filter)
                                 :on-change (fn [new-value]
                                              (swap! local-state assoc-in [:token/ip-filters idx :ip] new-value))}]
                               [:i.fal.fa-trash-alt
                                {:class    "cursor-pointer"
                                 :on-click (fn [_]
                                             (swap! local-state update
                                                    :token/ip-filters
                                                    (fn [old-value]
                                                      (vec (concat (subvec old-value 0 idx)
                                                                   (subvec old-value
                                                                           (inc idx)
                                                                           (count old-value)))))))}]]))
               (doall))
          [:div
           {:class "flex gap-4"}
           [button/primary-solid
            {:on-click (fn []
                         (swap! local-state assoc
                                :token/ip-filters
                                (vec (concat (get @local-state :token/ip-filters [])
                                             [{:name ""
                                               :ip   ""}])))
                         (deref local-state))}
            (loc/tr :add-ip-filter)]
           [button/secondary-hollow
            {:disabled? save-disabled?
             :on-click  #(when-not save-disabled?
                           (events/save! local-state token-state @local-state))}
            (loc/tr :save)]
           [button/secondary-hollow
            {:on-click #(events/rotate! token-state @local-state)}
            (loc/tr :rotate)]
           [button/danger-solid
            {:on-click #(events/revoke! token-state @local-state)}
            (loc/tr :revoke)]]]]))))

(defn api-tokens
  [local-state]
  [:div
   {:class "px-4 py-6 mx-auto max-w-5xl"}
   [:div
    [:div
     {:class "p-4"}
     [:div
      [:ul
       (doall
         (->> @local-state
              :api-tokens
              (map (fn [token]
                     ^{:key (str "api-token-" (:token/api-token token))}
                     [api-token local-state token]))))]]]]])

(defn content
  []
  (let [local-state (r/atom {:state :loading})]
    (events/load-api-tokens local-state)
    (fn []
      (cond (= :loading (:state @local-state))
            [loading]
            (empty? (:api-tokens @local-state))
            [advertisement]
            :else
            [api-tokens local-state]))))

(defmethod routing/render-view :new-settings/authorized-applications
  [_]
  [default-page-layout/view
   [:<>
    [zap-toolbar/view db/state breadcrumbs nil nil]
    [content]]])
